import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Empty from "../Empty";
import { useAreas } from "../../../hooks";
import SearchBar from "./SearchBar";
import AreaInfo from "./AreaDetails";
import { useTranslation } from "react-i18next";
import emptyImage from "assets/svg/emptyImg.svg";
import EmptyComponent from "components/EmptyComponent";

export default function AreasTab() {
  const { areas, addArea } = useAreas();
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex gap-2">
        <SearchBar />
        <div>
          <Button icon={<PlusOutlined />} block onClick={() => addArea()}>
            {t("add_area")}
          </Button>
        </div>
      </div>
      {areas.length <= 0 ? (
        <EmptyComponent image={emptyImage} description="添加主题区域以分组表" />
      ) : (
        <div className="p-2">
          {areas.map((a, i) => (
            <AreaInfo data={a} key={"area_" + i} i={i} />
          ))}
        </div>
      )}
    </div>
  );
}
